import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmFormRef, getKnmOnSaveButtonClick, getKnmStatus } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmPmFormAct } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormAct';
import { ErknmActExtract } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActExtract/ErknmActExtract';
import { ErknmActSignButton } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActSignButton/ErknmActSignButton';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { ActTypesEnum } from 'KnmErknmPackage/ErknmActsModule/enums';
import { ErknmActGeneral } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActGeneral/ErknmActGeneral';
import { ErknmActGeneralImpossible } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActGeneralImpossible/ErknmActGeneralImpossible';
import { ErknmActParticipants } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActParticipants/ErknmActParticipants';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { ErknmActEvents } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActEvents/ErknmActEvents';
import { IKnmPmFormRequirementsNpa } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRequirementsNpa';
import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { ErknmActSignInfo } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActSignInfo/ErknmActSignInfo';
import { ErknmActIntroductions } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActIntroductions/ErknmActIntroductions';
import { ErknmActRemarks } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActRemarks/ErknmActRemarks';
import { ErknmActAdditional } from 'KnmErknmPackage/ErknmActsModule/components/ErknmPaperlessActComponents/components/ErknmActAdditional/ErknmActAdditional';
import { getPmStartDate } from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';

import { PmActSubject } from './components/PmActSubject/PmActSubject';
import { PmActViolations } from './components/PmActViolations/PmActViolations';
import { IKnmStatus } from '../../../../../APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { IKnmErknmFormObject } from '../../../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { IKnmFormRiskIndicators } from '../../../../../KnmPackage/MainModule/interfaces/IKnmFormRiskIndicators';

interface IPmPaperlessActProps {
  value: IKnmPmFormAct;
  isWatchOnly: boolean;
  isDisabledField: boolean;
  isDisabledByDirty?: boolean;
  name: string;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  experts?: IKnmErknmFormExpert[];
  requirementsNpa: IKnmPmFormRequirementsNpa[] | undefined;
  knoOrganization: IDictionaryKnoOrganizationSelectOption | undefined;
  supervisionType: IDictionarySupervisionTypeSelectOption | undefined;
  objectsPm?: IKnmErknmFormObject[];
  riskIndicators?: IKnmFormRiskIndicators[];
}

interface IPmPaperlessActStoreProps {
  onSaveButtonClick: (() => void) | undefined;
  formRef: IKnmFormRef | undefined;
  knmStatus: IKnmStatus | undefined;
  startDate: string | undefined;
}

const PmPaperlessActWithoutStore = ({
  value,
  formRef,
  onSaveButtonClick,
  isDisabledField,
  name,
  inspectorsErknm,
  experts,
  requirementsNpa,
  knoOrganization,
  supervisionType,
  objectsPm,
  riskIndicators,
  knmStatus,
  isWatchOnly,
  isDisabledByDirty = false,
  startDate,
}: IPmPaperlessActProps & IPmPaperlessActStoreProps) => {
  const { typeAct } = value;

  if (!typeAct) return null;

  const isDisabled = isDisabledField || isDisabledByDirty || !!value.document;

  return (
    <>
      <ErknmActExtract extract={value.document} />
      {typeAct.id === ActTypesEnum.PM_PROF_ACT ? (
        <ErknmActGeneral
          isPm
          name={name}
          isDisabledField={isDisabled}
          prefixId={name}
          startDate={startDate}
          extractVersion={value.extractVersion}
          signActDateTime={value.signActDateTime}
        />
      ) : (
        <ErknmActGeneralImpossible isPm name={name} isDisabledField={isDisabled} value={value} prefixId={name} />
      )}
      {typeAct.id === ActTypesEnum.PM_PROF_ACT && (
        <>
          <PmActSubject id={name} name={name} value={value} />
          <ErknmActParticipants
            id={name}
            inspectorsErknm={inspectorsErknm}
            isDisabledField={isDisabled}
            name={name}
            expertsErknm={experts}
            involvedExperts={value.involvedExperts}
            formRef={formRef}
            isPm
          />
          <ErknmActEvents
            id={name}
            name={name}
            isDisabledField={isDisabled}
            formRef={formRef}
            isPm
            isPaperless={value.paperless}
            value={value}
            knmStatus={knmStatus}
          />
          <PmActViolations
            id={name}
            isWatchOnly={isWatchOnly}
            name={name}
            value={value}
            isDisabledField={isDisabledField || !!value.document}
            isDisabledByDirty={isDisabledByDirty}
            formRef={formRef}
            requirementsNpa={requirementsNpa}
            knoOrganization={knoOrganization}
            supervisionType={supervisionType}
            objectsPm={objectsPm}
            riskIndicators={riskIndicators}
          />
        </>
      )}
      <ErknmActSignInfo
        formRef={formRef}
        isPm
        value={value}
        id={name}
        isDisabledField={isDisabled}
        name={name}
        inspectors={inspectorsErknm}
      />
      {value.document && (
        <>
          <ErknmActIntroductions isPm id={name} name={name} formRef={formRef} isDisabledByDirty={isDisabledByDirty} />
          {typeAct.id === ActTypesEnum.PM_PROF_ACT && (
            <>
              <ErknmActRemarks
                isPm
                id={name}
                name={name}
                formRef={formRef}
                isDisabledByDirty={isDisabledByDirty}
                holdingDateTime={value.holdingDateTime}
              />
              {value.fileInvalidate && <ErknmActAdditional name={name} isPm attachment={value.fileInvalidate} />}
            </>
          )}
        </>
      )}
      <ErknmActSignButton value={value} formRef={formRef} onSaveButtonClick={onSaveButtonClick} isPm name={name} />
    </>
  );
};

const mapStateToProps = (state: IRootState): IPmPaperlessActStoreProps => ({
  onSaveButtonClick: getKnmOnSaveButtonClick(state),
  formRef: getKnmFormRef(state),
  knmStatus: getKnmStatus(state),
  startDate: getPmStartDate(state),
});

export const PmPaperlessAct = connect(mapStateToProps)(PmPaperlessActWithoutStore);
